/* eslint-disable no-case-declarations */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import _ from 'lodash';
import metadata from './MLHOValuableItemsUnspecifiedScheduledItemsComponent.metadata.json5';
import messages from './MLHOValuableItemsUnspecifiedScheduledItemsComponent.messages';
import appConfig from 'app-config';
import styles from './MLHOValuableItemsUnspecifiedScheduledItemsComponent.module.scss';
import { useTranslator } from '@jutro/locale';

const VALUABLE_ITEMS_UNSPECIFIED_TYPE = 'valuableItemsUnspecified';

// Used for HO Valuable Items Unspecified Within Home
function MLHOValuableItemsUnspecifiedScheduledItemsComponent(props) {
    const {
        items,
        defaultItem,
        schedItemType,
        readOnly,
        loading,
        parentRemoveItemHandler,
        resetChosenTermAndChosenTermValue,
        formatOptionAvailableVals,
        onCovChange
    } = props;

    const isQnB = appConfig.portalCode === 'QB';
    const translator = useTranslator();

    const isValuableItemsUnspecified = schedItemType === VALUABLE_ITEMS_UNSPECIFIED_TYPE;

    const getDefaultScheduleItem = useCallback(() => {
        const defaultValuableUnspecifiedItem = resetChosenTermAndChosenTermValue(defaultItem);
        return _.omit(defaultValuableUnspecifiedItem, ['fixedId']);
    }, [defaultItem, resetChosenTermAndChosenTermValue]);

    const onAddItem = useCallback(() => {
        const defaultItemVal = getDefaultScheduleItem();
        items.push(defaultItemVal);
        onCovChange(undefined, undefined, undefined, true);
    }, [getDefaultScheduleItem, items, onCovChange]);

    const onRemoveItem = useCallback((evt) => {
        parentRemoveItemHandler(evt.index, schedItemType);
    }, [parentRemoveItemHandler, schedItemType]);

    const dropdownChanged = useCallback((selectedOption, item) => {
        item.chosenTerm = selectedOption;
        item.updated = true;
        onCovChange(undefined,undefined,undefined,true);
    }, [onCovChange]);

    const onLimitChange = useCallback((value, item) => {
        item.limit = value;
        onCovChange(undefined,undefined,undefined,false);
    });

    const generateItemOverrides = useCallback(() => {
        const itemOverrides = items.map((item, itemIndex) => {
            return {
                [`actionRow${itemIndex}`]: {
                    visible: !readOnly,
                    className: loading ? 'cell disabled' : 'cell'
                },
                // Valuable Item Limit
                [`limitRow${itemIndex}`]: {
                    visible: isValuableItemsUnspecified
                },
                [`limitInputDiv${itemIndex}`]: {
                    visible: !readOnly && isValuableItemsUnspecified
                },
                [`limitInput${itemIndex}`]: {
                    visible: isValuableItemsUnspecified,
                    value: item.limit,
                    disabled: loading,
                    path: item.limit,
                    onValueChange: (value) => onLimitChange(value, item),
                    label: isQnB ? translator(messages.limit) : '',
                    labelClassName : isQnB ? 'valuableLabelStyle' : ''
                },
                [`limitReadonlyMobileSpan${itemIndex}`]: {
                    visible: readOnly && isValuableItemsUnspecified
                },
                [`limitReadOnlyContent${itemIndex}`]: {
                    visible: readOnly && isValuableItemsUnspecified
                },
                // Valuable Item Type
                [`typeSelectDiv${itemIndex}`]: {
                    visible: !readOnly,
                    className: isQnB ? 'typeStyle' : 'select'
                },
                [`typeDropdown${itemIndex}`]: {
                    value: item.type && item.type.chosenTerm,
                    availableValues: formatOptionAvailableVals(_.get(item, 'type.options', [])),
                    disabled: loading,
                    path: item.type,
                    onValueChange: dropdownChanged,
                    label: isQnB ? translator(messages.type) : '',
                    labelClassName : isQnB ? 'valuableLabelStyle' : ''
                },
                [`typeReadonlyMobileSpan${itemIndex}`]: {
                    visible: readOnly
                },
                [`typeReadOnlyContent${itemIndex}`]: {
                    visible: readOnly
                }
            };
        });

        return Object.assign({}, ...itemOverrides);
    }, [dropdownChanged, formatOptionAvailableVals, isValuableItemsUnspecified, items, loading, readOnly]);

    const overrides = {
        stackTableDiv: {
            className: readOnly ? 'stack-table' : 'stack-table plain'
        },
        actionHeader: {
            visible: !readOnly
        },
        tableRowIterable: {
            data: items
        },
        bottomButtonContainer: {
            visible: !readOnly
        },
        addItemBtn: {
            visible: !readOnly,
            disabled: loading
        },
        ...generateItemOverrides()
    };


    const resolvers = {
        resolveCallbackMap: {
            onAddItem,
            onRemoveItem
        },
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

MLHOValuableItemsUnspecifiedScheduledItemsComponent.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({})),
    schedItemType: PropTypes.string,
    defaultItem: PropTypes.shape({}),
    readOnly: PropTypes.bool,
    loading: PropTypes.bool,
    parentRemoveItemHandler: PropTypes.func,
    resetChosenTermAndChosenTermValue: PropTypes.func,
    onCovChange: PropTypes.func
};

export default MLHOValuableItemsUnspecifiedScheduledItemsComponent;
